import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { InsightsKeyword } from "@app/store/insights/state";

/**
 * Insights services to get keywords, etc. 
 *
 * @export InsightsApiService
 * @class InsightsApiService
 */
@Injectable({
    providedIn: "root",
})

export class InsightsApiService {
    udfApiUrl: string;

    constructor(private http: HttpClient) {
        this.udfApiUrl = environment.udfApiUrl;
        this.udfApiUrl = `${this.udfApiUrl}/api/Snowflake/`;
    }

    /**
     * Get insights keywords list.
     * 
     * @returns InsightsKeyword array list 
     */
    getKeyWords(): Observable<InsightsKeyword[]> {
        const returnedValues = this.http.get<InsightsKeyword[]>(`${this.udfApiUrl}getInsightsKeywords`)
        
        return returnedValues
        .pipe(
            catchError(this.handleHttpError)
        );
    }

    /**
     * Add a newer keyword to database. 
     * 
     * @param keyword The search input keyword 
     * @returns Observable success or failure
     */
    addKeyword(keyword: string): Observable<any> {
        const body = { keyword: keyword };
        return this.http.post<any>(`${this.udfApiUrl}addInsightsKeyword`, body)
        .pipe(
            catchError(this.handleHttpError)
        );
    }

    /**
     * Handle error messages. 
     * 
     * @param error Error message exception
     * @returns threw error message
     */
    handleHttpError(error) {
        console.error("An error ocurred while getting insights: ", error);
        return throwError(error.message || "Something went wrong, please try again later.");
    }
}
